// Fixed film-grain / noise overlay to kill digital flatness across the whole viewport.
export const Grain = () => (
  <div
    aria-hidden
    data-testid="grain-overlay"
    className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05] mix-blend-soft-light"
    style={{
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.82' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
    }}
  />
);
